import React from "react";
import { Link } from "react-router-dom";
const AdministratieMenu = ({ token, username, isActive, onToggle }) => {
  if (token.role === "admin") {
    return (
      <React.Fragment>
        <div className="menu-header">Admin Functies</div>
        <div className="menu-item">
          <div className="menu-link" onClick={onToggle}>
            <span className="menu-icon">
              <i className="fa fa-book"></i>
            </span>
            <span className="menu-text">Administratie</span>
            <span className={`menu-arrow ${isActive ? "rotate" : ""}`}>
              <i className="fas fa-chevron-right"></i>
            </span>
          </div>
          <div className={`menu-sub ${isActive ? "show" : ""}`}>
            <div className="menu-item">
              <Link to="/admin/bedrijven" className="menu-link">
                <span className="menu-icon">
                  <i className="fa fa-book"></i>
                </span>
                <span className="menu-text">Bedrijven</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/admin/gebruikers/" className="menu-link">
                <span className="menu-icon">
                  <i className="fa fa-users"></i>
                </span>
                <span className="menu-text">Gebruikers</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/admin/connections/" className="menu-link">
                <span className="menu-icon">
                  <i className="fa fa-plug"></i>
                </span>
                <span className="menu-text">Connections</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/admin/reserveringssystemen" className="menu-link">
                <span className="menu-icon">
                  <i className="fas fa-calendar-alt"></i>
                </span>
                <span className="menu-text">Reserveringssystemen</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/admin/betaalmethodes" className="menu-link">
                <span className="menu-icon">
                  <i className="fas fa-credit-card"></i>
                </span>
                <span className="menu-text">Betaalmethodes</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/admin/toegangscontrole" className="menu-link">
                <span className="menu-icon">
                  <i className="fas fa-lock"></i>
                </span>
                <span className="menu-text">Toegangscontrole</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/admin/apikeys" className="menu-link">
                <span className="menu-icon">
                  <i className="fas fa-key"></i>
                </span>
                <span className="menu-text">API Keys</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/admin/login-attempts" className="menu-link">
                <span className="menu-icon">
                  <i className="fas fa-shield-alt"></i>
                </span>
                <span className="menu-text">Login Attempts</span>
              </Link>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  } else {
    return null;
  }
};
export default AdministratieMenu;
